import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CommonNotificationService } from 'src/app/shared/services/common-notification/common-notification.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  public onsiteUserAuth$ = new Subject<void>();
  token = {
    refresh_token: 'refreshtokencode',
    exp: new Date((new Date().getDate() + 1)),
    access_token: {
      username: 'user'
      // roles: ['Admin', 'RegisteredUser', 'Super User']
    }
  };
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    })
  };

  tokenKey = 'a6smm_utoken';

  constructor(private router: Router, private httpClient: HttpClient,
    private commonNotificationService: CommonNotificationService,) {
    this.clearLocalStorage = this.clearLocalStorage.bind(this);
  }

  login(username, password) {
    this.setToken(this.token);
    // this.router.navigate(['design-components']);
    window.location.pathname = '/';
  }

  processLoginResponse = (response, username) => {
    if (response.is_error) {
      return;
    }
    this.token.access_token.username = username;
    this.setToken(this.token);
    // this.router.navigate(['actions']);
    window.location.pathname = '/';
  }

  inviteUser(payload, cb) {
    payload.dashboard_version = '3.0';
    return this.httpClient.put('../dashboard/confirmuserinvite', payload)
      .subscribe(
        (response: any) => {
          if (response.is_error) {
            this.commonNotificationService.showSnackBar(response.error_message, 'error');
            return;
          }
          return cb(response);
          // this.router.navigate(['login']);
        },
        error => {
        });
  }

  logout(cb?) {
    return this.httpClient.get('../dashboard/logout')
    .subscribe(
      (response: any) => {
        if (response.is_error) {
          this.commonNotificationService.showSnackBar(response.error_message, 'error');
          return;
        }
        this.clearLocalStorage();
        sessionStorage.removeItem('appReloadedOnce');
          if (this.isIframe()) {
            window.location.pathname = '/auth/ce-authenticate';
            return;
          }
          window.location.pathname = '/auth';
          if (cb) {
            return cb(response);
          }
        },
        error => {
        });
  }

  clearLocalStorage = () => {
    const lsKeys = Object.keys(localStorage);
    const keysToBeRemoved = lsKeys.filter(key => !(key.match(/_appListByUsage$/g) || key.match(/_selectedApp$/g)));
    keysToBeRemoved.forEach(key => localStorage.removeItem(key));
  }

  getToken() {
    return JSON.parse(localStorage.getItem(this.tokenKey));
  }

  setToken(token) {
    localStorage.setItem(this.tokenKey, JSON.stringify(token));
  }

  getAccessToken() {
    return JSON.parse(localStorage.getItem(this.tokenKey))['access_token'];
  }

  isAuthenticated() {
    const isTokenAvailable = localStorage.getItem(this.tokenKey) ? true : false;
    return isTokenAvailable;
  }

  refreshToken() {
    this.token.exp = new Date((new Date().getDate() + 1));
    this.setToken(this.token);
  }

  removeToken() {
    localStorage.removeItem(this.tokenKey);
  }

  fetchCEPanelDetail(params?) {
    return this.httpClient.post<any>("/dashboard/getsmtapiresponse", params, this.httpOptions).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  fetchSSOStatus() {
    return this.httpClient.get("../dashboard/getstatus");
  }

  fetchSSOUserStatus(status = false) {
    return this.fetchSSOStatus().subscribe(
      (response: any) => {
        if (response.is_error) {
          this.commonNotificationService.showSnackBar(
            response.error_message,
            "error"
          );
          setTimeout(() => {
            this.logout();
          }, 2000)
        } else {
          if (!status) {
            this.commonNotificationService.showSnackBar(
              "SSO user login successful",
              "success"
            );
            window.location.pathname = "/";
          }
        }
      },
      (error) => {
        this.commonNotificationService.showSnackBar(
          error,
          "error"
        );
      }
    );
  }

  getLocalStorageKey(key) {
    return JSON.parse(localStorage.getItem(key));
  }

  setLocalStorageKey(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  removeLocalStorageKey(key) {
    localStorage.removeItem(key)
  }

  authenticateCE(payload) {
    return this.httpClient.post('dashboard/ce/authenticate', payload);
  }

  cePostMessage(msg) {
    window.parent.postMessage(msg, "*");
  }

  isIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
}
